// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type {
  ApplicationGatewayWafDynamicManifestsDefaultGetOptionalParams,
  ApplicationGatewayWafDynamicManifestsDefaultGetResponse,
} from "../models/index.js";

/** Interface representing a ApplicationGatewayWafDynamicManifestsDefault. */
export interface ApplicationGatewayWafDynamicManifestsDefault {
  /**
   * Gets the regional application gateway waf manifest.
   * @param location The region where the nrp are located at.
   * @param options The options parameters.
   */
  get(
    location: string,
    options?: ApplicationGatewayWafDynamicManifestsDefaultGetOptionalParams,
  ): Promise<ApplicationGatewayWafDynamicManifestsDefaultGetResponse>;
}
